module.exports = __webpack_public_path__ + "static/hip-flash-1-c0067cc3f1fa8f4b71e390d9df59fee3.jpg";